import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { SpinnerComponent } from '../shared/components/spinner/spinner.component'
import { SideBarComponent } from '../shared/components/side-bar/side-bar.component'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { UserModel } from '../sections/users/user_model'
import { LoadingService } from '../shared/components/loading.service'
import { AuthService } from '../auth.service'
import { AuthStateService } from '../auth-state.service'
import { filter } from 'rxjs'
import { NotificationComponent } from '../shared/components/notification/notification.component'
import { MasterCommonServices } from '../sections/quotation/master.common.service'

@Component({
  selector: 'app-canvas',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    SideBarComponent,
    RouterOutlet,
    NotificationComponent,
  ],
  templateUrl: './canvas.component.html',
  styleUrl: './canvas.component.css',
})
export class CanvasComponent implements OnInit {
  userInfo: UserModel | undefined
  isLoading: boolean = true
  isLoggedIn: boolean | null = null
  itemList: Array<any> = []
  previousRoute: string | null = null
  permissions: string[] = []
  constructor(
    private loadingService: LoadingService,
    private authService: AuthService,
    private authStateService: AuthStateService,
    private masterCommonService: MasterCommonServices,
    public router: Router,
  ) {
    this.isLoading = true
  }
  ngOnInit(): void {
    this.loadingService.setLoading(true)

    this.authStateService.isLoggedIn.subscribe((loggedIn) => {
      this.masterCommonService.isDataLoaded = false
      this.isLoggedIn = loggedIn
      this.isLoading = true
      if (this.isLoggedIn == false) {
        this.isLoading = false
        this.previousRoute = '/auth/login'
      } else if (this.isLoggedIn == true) {
        this.authService.pingServer().subscribe({
          next: () => {
            this.authService.getPermissions(null).subscribe({
              next: (data) => {
                this.authStateService.setUserPermissions(data.permissions)
                this.isLoading = false
              },
              error: (error: any) => {
                this.isLoading = false
              },
            })
          },
          error: (error) => {
            if (error.status === 401) {
              this.isLoading = false
              this.authStateService.setLoggedIn(false)
              this.logout()
              this.router.navigateByUrl('/auth/login')
              return
            }
          },
        })
      }
      if (this.previousRoute && !this.previousRoute.includes('/auth')) {
        this.router.navigateByUrl(this.previousRoute)
      }
    })

    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
      this.initializeItemList()
    })
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url != '/auth/login' && event.url != '/auth/otp') {
          if (this.isLoggedIn === false) {
            this.router.navigateByUrl('/auth/login')
          }
        }
      })
  }

  initializeItemList(): void {
    const hasWorkOrderStatusPermission = this.permissions?.some((p) =>
      [
        'WorkOrdersStatusInvoicePermission',
        'WorkOrdersStatusOperationsPermission',
        'WorkOrdersStatusStickerPermission',
        'WorkOrdersStatusTCPermission',
      ].includes(p),
    )
    this.itemList = [
      { label: 'Home', link: '' },

      {
        label: 'Clients',
        child: [
          this.permissions?.includes('ClientsAddNewClientPermission')
            ? { label: '- Add Client', link: 'addClient' }
            : null,
          this.permissions?.includes('ClientsClientListPermission')
            ? { label: '- View Clients', link: 'viewClients' }
            : null,
        ].filter((item) => item !== null),
      },
      {
        label: 'Quotation',
        child: [
          this.permissions?.includes('QuotationsAddNewPermission')
            ? { label: '- Add Quotation', link: 'addQuotation' }
            : null,
          this.permissions?.includes('QuotationsPublishedListPermission') ||
          this.permissions?.includes('QuotationsDraftListPermission') ||
          this.permissions?.includes('QuotationsProformaListPermission')
            ? {
                label: '- View Quotations',
                link: 'viewQuotations',
              }
            : null,
          this.permissions?.includes('QuotationsFollowUpListPermission')
            ? { label: '- View Follow up List', link: 'viewFollowUps' }
            : null,
        ].filter((item) => item !== null),
      },

      this.permissions?.includes('MastersAccess')
        ? { label: 'Masters', link: 'masters' }
        : null,

      this.permissions?.includes('UserManagementAccess')
        ? { label: 'Users', link: 'users' }
        : null,

      {
        label: 'Vendors',
        child: [
          this.permissions?.includes('VendorsAddNewVendorPermission')
            ? { label: '- Add Vendor', link: 'addVendor' }
            : null,
          this.permissions?.includes('VendorsVendorListPermission')
            ? { label: '- View Vendors', link: 'viewVendors' }
            : null,
         
        ].filter((item) => item !== null),
      },
      {
        label: 'Purchase Order',
        child: [
          this.permissions?.includes('PurchaseOrdersAddNewPermission')
            ? { label: '- Add Purchase Order', link: 'addPurchaseOrder' }
            : null,
          this.permissions?.includes('PurchaseOrdersViewPermission')
            ? {
                label: '- View All Purchase Orders',
                link: 'viewPurchaseOrders',
              }
            : null,
        ].filter((item) => item !== null),
      },
      {
        label: 'Production',
        child: [
          this.permissions?.includes('WorkOrdersAddNewPermission')
            ? { label: '- Add Work Order', link: 'addWorkOrder' }
            : null,
          this.permissions?.includes('WorkOrdersViewPermission')
            ? {
                label: '- View All Work Orders',
                link: 'viewAllWorkOrders',
              }
            : null,
          hasWorkOrderStatusPermission
            ? {
                label: '- View Work Orders Status',
                link: 'viewWorkOrdersStatus',
              }
            : null,
          this.permissions?.includes('WorkOrdersPartNumberMasterPermission')
            ? { label: '- Part Number', link: 'partNumber', disabled: false }
            : null,
        ].filter((item) => item !== null),
      },
    ].filter((item) => item !== null && (!item.child || item.child.length > 0))
  }

  onItemSelected(item: any) {
    this.router.navigateByUrl(item.link)
  }

  logout(): void {
    this.authService.logout()
    this.authStateService.setLoggedIn(false)
  }
}
